<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-lg hidden-xl navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">{{form.cod ? 'Editar' : 'Adicionar'}} agendamento</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content content-area pt-70 bottom-sp70">
              
            <div class="container hidden-xs hidden-md">
                <h2>{{form.cod ? 'Editar' : 'Adicionar'}} agendamento</h2>
            </div>

            <div class="">
                <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list media-list list-outline-ios list-strong-ios list-dividers-ios" style="margin-top: 16px">
                        <ul class="row">
                            <li class="item-content item-input col-100" style="margin-bottom: 0px; min-height: 25px;">
                                <div class="item-inner" style="margin-bottom: 0px; min-height: 0px">
                                    <div class="item-title item-label" style="margin-bottom: 0px;">Como deseja prosseguir?</div>
                                </div>
                            </li>                             
                            <li class="col-100">
                                <label class="item-radio item-radio-icon-start item-content" >
                                    <input type="radio" value="meus-pacientes" name="paciente" v-model="form.paciente">
                                    <i class="icon icon-radio"></i>
                                    <div class="item-inner">
                                        <div class="item-title">Selecionar um paciente</div>
                                    </div>
                                </label>
                            </li>
                            <li class="col-100">
                                <label class="item-radio item-radio-icon-start item-content" >
                                    <input type="radio" value="selecionar" name="paciente" v-model="form.paciente">
                                    <i class="icon icon-radio"></i>
                                    <div class="item-inner">
                                        <div class="item-title">Pesquisar paciente por e-mail</div>
                                    </div>
                                </label>
                            </li>
                            <li class="col-100">
                                <label class="item-radio item-radio-icon-start item-content">
                                    <input type="radio" value="cadastrar" name="paciente" v-model="form.paciente">
                                    <i class="icon icon-radio"></i>
                                    <div class="item-inner">
                                        <div class="item-title">Cadastrar novo paciente</div>
                                    </div>
                                </label>
                            </li>       
                            <li class="item-content item-input col-100 mt-10" v-if="form.paciente == 'meus-pacientes'">
                                <div class="item-inner">
                                    <div class="item-title item-label">Selecione o paciente (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <select id="usuarioCod" class="form-control" readonly="" name="usuarioCod" required="" v-model="form.usuarioCod" >
                                            <option value="" disabled selected hidden>{{pacientes.itens.length > 0 ? 'Selecione..' : 'Você não possui nenhum paciente cadastrado.'}}</option>
                                            <option :value="item.cod" v-for="(item, index) in pacientes.itens" :key="'paciente-' + item.cod">{{item.nome}} ({{ item.email }})</option>
                                        </select>                                         
                                        <!-- <small style="white-space: break-spaces;">Digite o e-mail do paciente para buscar seu cadastro no aplicativo.</small> -->
                                    </div>
                                </div>
                                <hr class="mt-20">
                            </li>
                            <li class="item-content item-input col-100 mt-10" v-if="form.paciente == 'selecionar'">
                                <div class="item-inner">
                                    <div class="item-title item-label">E-mail do paciente (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="text" placeholder="Escreva o e-mail do paciente.." v-model="form.email" class="form-control"/>
                                        <small style="white-space: break-spaces;">Digite o e-mail do paciente para buscar seu cadastro no aplicativo.</small>
                                    </div>
                                </div>
                                <hr class="mt-20">
                            </li>

                            <li v-if="paciente && form.paciente == 'selecionar'" class="item-content item-input col-100" style="margin-bottom: 0px; min-height: 25px;">
                                <div class="item-inner" style="margin-bottom: 0px; min-height: 0px">
                                    <div class="item-title item-label" style="margin-bottom: 0px;">
                                        Paciente encontrado:
                                    </div>
                                </div>
                            </li>                             
                            <li class="col-100 mb-10" v-if="paciente && form.paciente == 'selecionar'">
                                <label class="item-link item-content item-radio item-radio-icon-start">
                                    <input type="radio" :value="paciente.usuario.cod" name="usuarioCod" v-model="form.usuarioCod">
                                    <i class="icon icon-radio"></i>                                    
                                    <div class="item-inner">
                                        <div class="item-title-row">
                                            <div class="item-title">{{paciente.usuario.nome}}</div>
                                        </div>
                                        <div class="item-subtitle">{{paciente.usuario.email}}</div>
                                        <div class="item-text">
                                            <!-- <small>Cadastrado em {{paciente.usuario.datahora}}</small> -->
                                        </div>
                                    </div>
                                </label>
                            </li>  
                            <!-- <li v-if="pacientes.itens.length > 0 && pacientes.loaded && form.paciente == 'selecionar'" class="item-content item-input col-100" style="margin-bottom: 0px; min-height: 25px;">
                                <div class="item-inner" style="margin-bottom: 0px; min-height: 0px">
                                    
                                </div>
                            </li>                                    -->
                            <!-- <li v-if="form.paciente == 'cadastrar'" class="item-content item-input col-100" style="margin-bottom: 0px; min-height: 25px;">
                                <div class="item-inner" style="margin-bottom: 0px; min-height: 0px">
                                    <div class="item-title item-label" style="margin-bottom: 0px;">
                                        <small style="color: red">Preencha corretamente os dados do paciente para cadastrá-lo no aplicativo. <b>Ele receberá a senha de acesso no e-mail</b>.</small>
                                    </div>
                                </div>
                            </li>   -->

                            <li v-if="form.paciente == 'cadastrar'" class="item-content item-input col-100 mb-40" style=" min-height: 25px;">
                                <div class="item-inner" style="margin-bottom: 0px; min-height: 0px">
                                    <div class="item-title item-label" style="margin-bottom: 0px;">
                                        <small style="color: red">Para cadastrar um novo paciente toque no botão abaixo.</small>
                                    </div>
                                    <div class="item-text" style="min-height: 100%;">
                                        <button v-on:click="$root.go('CadastrarPacientes', JSON.stringify({'tipo':'novo-agendamento', 't': Math.random()}))" type="button" class="button mt-5 button-fill button-round button-large">
                                            <i class="las la-plus"></i>
                                            Cadastrar paciente
                                        </button>
                                        <hr class="mt-20">
                                    </div>
                                </div>
                            </li>  

                            <!-- <li v-if="form.paciente == 'cadastrar'" class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome do paciente <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="text" v-model="form.nome" placeholder="Escreva o nome aqui" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li v-if="form.paciente == 'cadastrar'" class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">E-mail do paciente <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <input type="email" v-model="form.email" placeholder="Escreva o e-mail corretamente" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>                         
                            <li v-if="form.paciente == 'cadastrar'" class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Telefone/Celular do paciente <small>(obrigatório)</small></div>
                                    <div class="item-input-wrap">
                                        <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva o celular" autocomplete="new-password" v-model="form.telefone" />
                                    </div>
                                </div>
                            </li>  -->
                            <li class="item-content item-input col-100" v-show="form.usuarioCod">
                                <div class="item-inner">
                                    <div class="item-title item-label">Descrição do atendimento (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="text" placeholder="Escreva o nome do atendimento.." v-model="form.descricao" class="form-control"/>
                                    </div>
                                </div>
                            </li> 

                            <li class="item-content item-input col-100" v-show="form.usuarioCod">
                                <div class="item-inner">
                                    <div class="item-title item-label">Data do agendamento (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="date" v-model="form.data" class="form-control"/>
                                    </div>
                                </div>
                            </li> 

                            <li class="item-content item-input col-100" v-show="form.usuarioCod">
                                <div class="item-inner">
                                    <div class="item-title item-label">Hora do agendamento (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="time" placeholder="" v-model="form.hora" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                                               

                            <li class="item-content item-input col-100" v-show="form.usuarioCod">
                                <div class="item-inner">
                                    <div class="item-title item-label">Duração - em minutos (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="number" placeholder="__" v-model="form.duracao" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div class="row mt-20">

                        </div>                          
                    </div>

                    <div class="block" v-show="form.usuarioCod">
                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>

        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'GerenciarPedidos',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "pesquisa":            "",
            "loading": {
                "submit":           false
            },
            "pacientes": {
                "itens":            []
            },
            "paciente":            null,          
            "form": {
                "usuarioCod":       "",
                "email":            "",
                "paciente":         "",
                "descricao":        "Consulta",
                "duracao":          "60",
                "doc":              ""
            }            
        }
    },
    watch: {
        "form.paciente": function(val) {
            var self = this;
            console.log("watch form.paciente >>", val);

            if (val == "meus-pacientes") {
                self.getPacientes();
            }

            self.form.email         = "";
            self.form.usuarioCod    = "";
            self.$forceUpdate();

        },
        "form.email": function(val) {
            var self = this;
            console.log("watch form.email >>", val);

            // if (val) {
                // if (val.length == 11) {
            if (!val) return false;
            self.pesquisarPaciente(val);
                // }
            // }
        }
    },
    methods: {   
        solicitarAcesso: function() {
            var self = this;
            console.log("solicitarAcesso()", self.form);

            var form                = {
                "acao":             "solicitar-acesso",
                "email":            pesquisa
            }
            loading.show();
            
            axios.put("api/pacientes-v2.php", form, {authentication: true})
            .then(response => {
                console.log("solicitarAcesso() responde", response.data);
                loading.hide();
                alert(response.data.message);
            })
            .catch(error => {
                console.log("solicitarAcesso() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },          
        pesquisarPaciente: function(pesquisa) {
            var self        = this;
            console.log("pesquisarPaciente()", pesquisa);
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "pesquisa",
                        "email":        pesquisa
                    }
                };

                axios.get("api/pacientes-v2.php", form)
                .then(response => {
                    
                    console.log("pesquisarPaciente() response", response);

                    // if (response.data.message) {

                    //     let button  = null;

                    //     if (response.data.result.solicitar) {
                    //         button      = {
                    //             text: '✅ Enviar solicitação',
                    //             onClick: function() {
                    //                 self.solicitarAcesso();
                    //             }
                    //         };
                    //     } else {
                    //         button      = {
                    //             text: 'Ok, entendi',
                    //             onClick: function() {

                    //             }
                    //         };                            
                    //     }

                    //     window.___app.dialog.create({
                    //         title: '',
                    //         text: response.data.message,
                    //         buttons: [
                    //             button,
                    //             {
                    //                 text: 'Cancelar',
                    //                 onClick: function() {
                    //                 }
                    //             }                                                         
                    //         ],
                    //         verticalButtons: true,
                    //     }).open(); 

                    // } 
                    if (response.data.result.usuario) {
                        self.paciente           = response.data.result;
                        self.form.usuarioCod    = response.data.result.usuario.cod;
                    }  else {
                        self.paciente           = null;
                        self.form.usuarioCod    = null;
                    }
                    
                    self.$forceUpdate();
                    // loading.hide();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("pesquisarPaciente() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                    
                });   
            });   
        },                   
        submit: function(e) {
            
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));

            // if (self.pacientes.itens.length == 0 && !self.form.email && !self.form.nome) {
            //     alert("Selecione ou cadastre um paciente para prosseguir.");
            //     return false;
            // } else {
            //     self.form.usuarioCod = self.pacientes.itens[0].cod;
            // }

            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            axios[a]("api/agendamentos.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                // alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getPacientes: function() {
            var self        = this;
            console.log("getPacientes()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1,
                        "tipo":         "contratante"
                        // "cod":          self.form.cod
                    }
                };

                axios.get("api/pacientes-v2.php", form)
                .then(response => {
                    
                    console.log("getPacientes() response", response);
                    self.pacientes           = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getPacientes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/agendamentos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {
            var self = this;
            console.log("init()");

 
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarServicos") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }

        self.init();
    },
    activated: function() {
        var self = this;
    },       
    mounted: function() {
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .button-round {
        border-radius: 20px !important;
    }

    .badge-large {
        padding: 15px;
    }

    .badge-outline:not(.color-green) {
        background: transparent !important;
        border: 2px solid var(--f7-theme-color-shade) !important;
        color: var(--f7-theme-color-shade);
    }

    .badge.color-secondary {
        border: 2px solid var(--f7-theme-color-shade) !important;
    }

    .badge.color-primary {
        border: 2px solid var(--f7-theme-color) !important;
    }    

    .badge.color-green:not(.badge-outline) {
        border: 2px solid #4cd964 !important;
    }

    .badge-outline.color-green {
        background: transparent !important;
        border: 2px solid #4cd964 !important;
        color: #4cd964;
    }    

    .container {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/GerenciarPedidos.vue